export const preLoadResource = (url, type = 'other') => {
  const link = document.createElement('link');
  link.href = url;
  link.rel = 'preload';

  switch (type) {
    case 'image':
      link.as = 'image';
      break;
    case 'video':
      link.as = 'video';
      break;
    case 'script':
      link.as = 'script';
      break;
    case 'style':
      link.as = 'style';
      break;
    // 可以根据需要添加更多类型
  }

  document.head.appendChild(link);
};
